import { FC, ReactNode } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import WarningIcon from '@material-ui/icons/Warning';
interface Props {
  children: ReactNode;
  dialogOpen: boolean;
  handleOpen: () => void;
  unlockItem?: (id: string) => Promise<void> | void;
  unlockId: string;
}

const UIUnlockDialog: FC<Props> = (props) => {
  const handleDelete = () => {
    if (props.unlockItem) {
      props.unlockItem(props.unlockId);
    }
    props.handleOpen();
  };
  return (
    <div>
      <Dialog
        open={props.dialogOpen}
        onClose={props.handleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="simple-dialog-title">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <WarningIcon />
            <span style={{ marginLeft: '5px' }}>アカウントロックの解除</span>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.children}
            <br />
            この操作は取り消しできません。
            <br />
            本当にロックを解除しますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={props.handleOpen} variant="outlined">
            戻る
          </Button>
          <Button
            autoFocus
            color="primary"
            variant="contained"
            onClick={handleDelete}
          >
            解除
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UIUnlockDialog;
